/* tslint:disable */
/* eslint-disable */
/**
 * Mailbox API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const MailTemplateLanguage = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;
export type MailTemplateLanguage = typeof MailTemplateLanguage[keyof typeof MailTemplateLanguage];


export function instanceOfMailTemplateLanguage(value: any): boolean {
    for (const key in MailTemplateLanguage) {
        if (Object.prototype.hasOwnProperty.call(MailTemplateLanguage, key)) {
            if (MailTemplateLanguage[key as keyof typeof MailTemplateLanguage] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MailTemplateLanguageFromJSON(json: any): MailTemplateLanguage {
    return MailTemplateLanguageFromJSONTyped(json, false);
}

export function MailTemplateLanguageFromJSONTyped(json: any, ignoreDiscriminator: boolean): MailTemplateLanguage {
    return json as MailTemplateLanguage;
}

export function MailTemplateLanguageToJSON(value?: MailTemplateLanguage | null): any {
    return value as any;
}

export function MailTemplateLanguageToJSONTyped(value: any, ignoreDiscriminator: boolean): MailTemplateLanguage {
    return value as MailTemplateLanguage;
}

